export const LocaleNames = {
  enUS: 'English',
  deDE: 'Deutsch',
  esES: 'Espa\u00f1ol',
  frFR: 'Fran\u00e7ais',
  itIT: 'Italiano',
  koKR: '\ud55c\uad6d\uc5b4',
  plPL: 'Polski',
  ptBR: 'Portugu\u00eas',
  ruRU: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439',
  zhCN: '\u7b80\u4f53\u4e2d\u6587',
  zhTW: '\u7e41\u9ad4\u4e2d\u6587'
}

export const Seasons = {
  None: 0,
  Grandeur: 16,
  Nightmares: 17,
  Triune: 18,
  Pandemonium: 19,
  Archives: 20,
  Shadows: 22,
  Ethereal: 24,
  SoulShards: 25,
  Sanctified: 26,
  Altar: 28,
  Enmity: 29
}

export function getStoredValue(key, defaultValue, session = false) {
  try {
    const item = (
      session ? window.sessionStorage : window.localStorage
    ).getItem(key)
    return item != null
      ? JSON.parse(item)
      : typeof defaultValue === 'function'
      ? defaultValue()
      : defaultValue
  } catch (error) {
    console.error(error)
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue
  }
}

export function removedStoredValue(key, session = false) {
  try {
    ;(session ? window.sessionStorage : window.localStorage).removeItem(key)
  } catch (error) {
    console.error(error)
  }
}

export function setStoredValue(key, value, session = false) {
  try {
    ;(session ? window.sessionStorage : window.localStorage).setItem(
      key,
      JSON.stringify(value)
    )
  } catch (error) {
    console.error(error)
  }
}

export function getCookies() {
  const result = []
  for (const cookie of document.cookie.split(';')) {
    const parts = cookie.split('=')
    if (parts.length === 2) {
      result[parts[0].trim()] = decodeURIComponent(parts[1].trim())
    }
  }
  return result
}

/* CONFIGURATION */

export const Game = 'd3'

export const HasPTR = false
const parts =
  typeof window === 'undefined'
    ? ['d3planner']
    : window.location.pathname.split('/')
export const PTR =
  HasPTR && (parts.includes('d3planner-ptr') || !parts.includes('d3planner'))
export const CurrentSeason = Seasons.Enmity
export const BuildInfoLevel = 3
export const MaxProfileSets = 24
export const MaxProfileSetName = 36

//export const getIconPath = id => `/icons/${id}.png`;
//export const getTypeIconsPath = type => `/itemtypes/${type}.png`;
//export const getApiPath = action => `/${action}`;

const isDev =
  typeof process !== 'undefined' && process.env.NODE_ENV === 'development'

const assets_path = 'https://d3planner.maxroll.gg/d3planner-data/'
const public_assets_path = 'https://d3planner-assets.maxroll.gg/d3planner/'

export const getProfilePath = PTR
  ? (id) => `/d3/d3planner-ptr/${id}`
  : (id) => `/d3/d3planner/${id}`
export const getIconPath = (id) =>
  `https://d3planner-assets.maxroll.gg/icons/${id}.png`
export const getAssetsPath =
  typeof process === 'undefined'
    ? (path) => `${public_assets_path}${path}`
    : (path) =>
        process.env.PUBLIC_URL + `/${path}?${process.hashes?.[path] || ''}`
export const getTypeIconsPath = (type) => getAssetsPath(`css/items/${type}.png`)

export const getApiPath = (action) => `https://planners.maxroll.gg/${action}`
export const getStaticApiPath = getApiPath

let _isEmbed = null

export const isEmbed = () => _isEmbed
export const EMBED_setEmbed = () => (_isEmbed = true)
